import {
  DisablePaypalIntegrationRequestParams,
  DisablePaypalIntegrationResponse,
  FetchPaypalOnboardingLinkRequestParams,
  FetchPaypalOnboardingLinkResponse,
  FetchShorePayOnlineOnboardingLinkRequestParams,
  FetchShorePayOnlineOnboardingLinkResponse,
  ToggleSubPaymentMethodRequestParams,
  ToggleSubPaymentMethodResponse,
  ToggleSubPaymentMethodV2RequestParams,
  ToggleSubPaymentMethodV2Response,
} from '../types';

export async function fetchPaypalOnboardingLink({
  apiClient,
  merchantId,
}: FetchPaypalOnboardingLinkRequestParams): Promise<FetchPaypalOnboardingLinkResponse> {
  const payload = { merchant: { id: merchantId } };
  return apiClient.payPal.signupLink.create(payload);
}

export async function disablePaypalIntegration({
  apiClient,
  merchantId,
}: DisablePaypalIntegrationRequestParams): Promise<DisablePaypalIntegrationResponse> {
  const payload = { merchant: { id: merchantId } };
  return apiClient.payPal.deactivate.create(payload);
}

export async function fetchShorePayOnlineOnboardingLink({
  apiClient,
  company,
  taxId,
  merchantId,
}: FetchShorePayOnlineOnboardingLinkRequestParams): Promise<FetchShorePayOnlineOnboardingLinkResponse> {
  const payload = {
    source: company,
    merchant_id: merchantId,
    ...(taxId && { tax_number: taxId }),
  };
  return apiClient.shorepayV1.initiateAccountCreation(payload);
}
// TODO:max update data is the next PR.
export async function toggleSubPaymentMethodV2({
  subPaymentMethodName,
  enabled,
}: ToggleSubPaymentMethodV2RequestParams): Promise<ToggleSubPaymentMethodV2Response> {
  await new Promise((resolve) => setTimeout(resolve, 2000));
  return { data: { name: subPaymentMethodName, enabled } };
}

// TODO:max update data is the next PR.
export async function toggleSubPaymentMethod({
  subPaymentMethodName,
  enabled,
}: ToggleSubPaymentMethodRequestParams): Promise<ToggleSubPaymentMethodResponse> {
  await new Promise((resolve) => setTimeout(resolve, 2000));

  return {
    data: {
      name: subPaymentMethodName,
      displayName: subPaymentMethodName.replace(/_/g, ' '),
      enabled,
      icons: [],
    },
  };
}
